import { SitngoTypeAbstract } from "./SitngoTypeAbstract";

export class SitngoTypeStandard extends SitngoTypeAbstract {
}
